import getAPIPath from '../modules/api-location';


window.filterContentService = function(includeLocked, saveParams, ages, contentTypes, cursor, pageSize, successFn) {
  let params = ``;

  for (let i = 0; i < ages.length; i++) {
    const age = ages[i];
    params = `${params}ages=${age}&`;
  }

  for (let i = 0; i < contentTypes.length; i++) {
    const contentType = contentTypes[i];
    // This is needed so that we don't pass in a blank string if 'everything' is selected
    if (contentType !== ``) {
      params = `${params}types=${contentType}&`;
    }
  }

  return $.ajax({
    url: `${getAPIPath}queryapi/custom-content-feed?allContentLevels=${includeLocked}&saveParams=${saveParams}&${params}&cursor=${cursor}&pageSize=${pageSize}`,
    type: `get`,
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
};


window.customContentService = function(successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/custom-content-params`,
    type: `get`,
    success: successFn,
    async: true,
    xhrFields: {
      withCredentials: true,
    },
  });
};



// WEBPACK FOOTER //
// ./library/js/services/contentfeed.service.js